import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { GuestReason } from 'src/features/parkingManagement/api/ReasonsForGuest/useGetParkingGuestReasons';
import type { GeneralSmartParkError } from 'src/types/errors';

interface DTO {
    parkingId: string;
    id: string;
}
const RESOURCE = '/parkings/:parkingId/parking-guest-reason/:id/';

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, id, ...data }: DTO): Promise<GuestReason> => {
    return axios.patch(formatResourcePath(RESOURCE, { parkingId, id }), data);
};

interface UseMutationOptions extends MutationConfig<MutationFnType, GeneralSmartParkError> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateParkingGuestReason };
